// Bootstrap importieren
import 'bootstrap';

// FontAwesome importieren
import '@fortawesome/fontawesome-free/js/all';

// SCSS hier importieren
import '../scss/style.scss';

// Listing Gallery JS importieren
import './listing-gallery.js';

// Google Maps JS importieren
import './maps.js';
